const elemStationLocator = document.querySelectorAll('.c24-StationLocator');

window.fireOnVisible(elemStationLocator, async(rootElement) => {
    await import('./assets/css/station_locator.scss');

    const stationLocatorInit = new Promise(async(resolve) => {
        window.TCMS.stationLocator = null;

        if (window.ck24_StationLocator_MapOptions.layoutType === 'city_stations') {
            await import('./assets/css/station_locator_city.scss');
            await import('./assets/js/StationLocatorCity.ts').then((StationLocatorCityDefault) => {
                const { StationLocatorCity } = StationLocatorCityDefault;

                resolve(StationLocatorCity);
            });
        } else if (window.ck24_StationLocator_MapOptions.layoutType === 'region_offers') {
            await import('./assets/css/station_locator_region_offers.scss');

            await import('./assets/js/StationLocatorRegion.ts').then((StationLocatorRegionDefault) => {
                const { StationLocatorRegion } = StationLocatorRegionDefault;

                resolve(StationLocatorRegion);
            });
        }
    });

    stationLocatorInit.then((StationLocator) => {
        const stationLocatorOptions = window.ck24_StationLocator_MapOptions;
        const googleMapOptions = window.ck24_googleMapOptions;

        new StationLocator(rootElement, {
            markerConfigs: stationLocatorOptions.markers,
            layoutType: stationLocatorOptions.layoutType,
            translations: stationLocatorOptions.translations,
            hasCluster: googleMapOptions.markerClusterOn,
            maxZoom: googleMapOptions.definedZoomLevel,
            scrollToTarget: window.scrollToTarget,
            vertical: window.TCMS.product,
            isMobile: window.TCMS.isMobile,
            lazyloader: window.c24_lazyloadLibs.lazyLoad
        });
    });
});

const elemStationLocatorTabbar = document.querySelector('.c24-StationLocator .wdgt-Tabbar');

window.fireOnVisible(elemStationLocatorTabbar, async() => {
    await import('../Tabbar/assets/js/tabbar.ts').then((Tabbar) => {
        Tabbar = Tabbar.default;
        window.TCMS.tabBar = new Tabbar();
    });
});
